/* @flow */

import type { CombinedReducers } from '../../redux/reducers';
import type { SecurityInfoType } from './HeaderConstsAndTypes';

import { logError, logInfo } from '../../helpers/debug/debug';
import { StorageKeys } from '../../helpers/localStorage/keys';
import LocalStorageManager from '../../helpers/localStorage/localStorageManager';
import { getSettingValueByName } from '../../redux/netgemApi/actions/helpers/settings';

let securityInfoKey: string | null = null;
let securityInfoValue: SecurityInfoType = {};

const buildSecurityInfo: (state: CombinedReducers) => SecurityInfoType = (state) => {
  const {
    appConfiguration,
    appConfiguration: { distributorAppKeys, mainDistributorId, productId },
    appRegistration: { applicationId, authenticationToken, deviceKey, subscriberId, userInfo },
  } = state;

  const cacheKey = [applicationId, authenticationToken, deviceKey, subscriberId].join('+');
  if (securityInfoKey !== null && cacheKey === securityInfoKey) {
    return securityInfoValue;
  }

  const device = getSettingValueByName('platform.vf', 'device', appConfiguration);
  const email = userInfo?.email;
  const firebaseToken = LocalStorageManager.loadString(StorageKeys.FcmToken, '');

  securityInfoKey = cacheKey;
  securityInfoValue = {
    applicationId,
    authenticationToken,
    device,
    deviceKey,
    email,
    firebaseToken,
    mainDistributorId,
    productId,
    subscriberId,
  };

  Object.entries(distributorAppKeys).forEach(([appKey, distributorId]) => {
    securityInfoValue[`appKey for ${distributorId}`] = appKey ?? '<missing appkey>';
  });

  return securityInfoValue;
};

const logSecurityInfo: (securityInfo: SecurityInfoType) => void = (securityInfo) => {
  logInfo('########### Security info ###########');
  Object.entries(securityInfo).forEach(([key, value]) => logInfo(`${key}: ${typeof value === 'string' ? value : ''}`));
  logInfo('#####################################');

  // Also copy application Id to clipboard because it's commonly used by developers to look for a device in DMS
  const { applicationId } = securityInfo;
  if (applicationId) {
    navigator.clipboard
      .writeText(applicationId)
      .then(() => logInfo('Application Id was copied to clipboard.'))
      .catch(() => logError('Error copying Application Id to clipboard.'));
  }
};

const getHeaderClass: (isInTheaterMode: boolean, isLogoLoaded: boolean, isScrolling: boolean) => string = (isInTheaterMode, isLogoLoaded, isScrolling) => {
  const headerClass = [];

  if (isInTheaterMode) {
    headerClass.push('slideUp');
  } else if (isLogoLoaded) {
    headerClass.push('slideDown');
  }

  if (isScrolling) {
    headerClass.push('scroll');
  }

  return headerClass.join(' ');
};

export { buildSecurityInfo, getHeaderClass, logSecurityInfo };
